export class JsonStream {
  constructor(separator = '§') {
    this.size = 0;
    this.json = [];
    this.separator = separator;
    this.current = -1;
    this.done = false;
  }

  add(chunk) {
    let incomingJson = chunk.split(this.separator).filter(c => c !== '');
    this.json = [...incomingJson];
    this.json = this.json.map(j => {
      let rec;
      try {
        rec = JSON.parse(j);
        return rec;
      } catch (err) {
        //return null
      }
    });
    this.size = this.json.length;
  }

  getJson() {
    return this.json;
  }
  nextJson() {
    let look = this.current;
    if (
      !this.done &&
      /** there is an element at current position*/ this.json[++look] !== undefined
    ) {
      this.current++;
    }
    return this.json[this.current];
  }
  setDone(done) {
    this.done = done;
  }
}
